import type { OriginRoleItem } from './type';
import { requestGet } from '@/utils/request';
import type { TApi } from '@/types/interface';

export async function getTreeList(): Promise<TApi<OriginRoleItem[]>> {
  return requestGet(`/v2/camp/api/user/role/tree`, {});
}
